



















































































































import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {validationMixin} from "vuelidate";
import XForm from "../SimpleForm.vue";
import XButton from "../SimpleButton.vue";
import XDialog from "../SimpleDialog.vue";
import AppApiMixin from "../mixins/AppApi.vue";
import {countersNewValueForm} from "@/assets/scripts/form-fields/main";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import XDateTimeField from "@/components/hoc/DateTimeField.vue";
import {mapMutations, mapState} from "vuex";
import { Indication } from "@/models/indications";
import moment from "moment";

const { values, attrs, validations, errors } = countersNewValueForm;

@Component({
  components: {
    XForm,
    XButton,
    XDialog,
    XNotice,
    XDateTimeField,
  },
  mixins: [validationMixin],
  computed: {
    ...errors,
    ...mapState({
      accountingPointsPU: "accountingPoints",
    }),
    workingInvalid() {
      if (!this.elPu) {
        return false;
      }
      return this.invalidWorkingFlag || this.invalidWorkingTimeFlag;
    }
  },
  methods: {
    ...mapMutations("error", { setShow: "setShow", setMessage: "setMessage" }),
  },
  validations,
})
class CountersNewValueForm extends Mixins(XForm, AppApiMixin) {
  @Prop({ required: true }) readonly rate!: number;
  @Prop({ required: true }) readonly rateFloat!: number;
  @Prop({ required: true }) readonly meteringPointId!: number;
  @Prop({ required: true }) readonly counterId!: number;
  @Prop({ required: true }) readonly zones!: number;
  @Prop({ required: true }) readonly disabled!: boolean;
  @Prop({ required: true, default: false }) readonly elPu!: boolean;

  values = { ...values };
  allFieldAttrs = attrs;

  useSubmitButtonLoading = false;
  submitError = "";

  invalidRateFlag = true;
  invalidRate = []; // [ true, true, true ];
  rateFlag = []; // [ false, false, false ];

  working = []; // [ "", "", "" ];
  invalidWorkingFlag = this.elPu;
  invalidWorking = []; // [ true, true, true ];
  workingFlag = []; // [ false, false, false ];

  workingTime = []; // [ "", "", "" ];
  invalidWorkingTimeFlag = this.elPu;
  invalidWorkingTime = []; // [ true, true, true ];
  workingTimeFlag = []; // [ false, false, false ];

  showDialog = false;

  useSuccessAlert = false;
  successMessage = "Показания успешно переданы на обработку";

  @Watch('zones')
  zonesChanged(newVal) {
    if (newVal > 0) {
      this.invalidRate = [];
      this.rateFlag = [];
      this.working = [];
      this.invalidWorking = [];
      this.workingFlag = [];
      this.workingTime = [];
      this.invalidWorkingTime = [];
      this.workingTimeFlag = [];
      for (let i = 0; i < newVal; i++) {
        this.invalidRate.push(true);
        this.rateFlag.push(false);
        this.working.push("");
        this.invalidWorking.push(true);
        this.workingFlag.push(false);
        this.workingTime.push("");
        this.invalidWorkingTime.push(true);
        this.workingTimeFlag.push(false);
      }
    }
  }

  get indications() {
    return this.accountingPointsPU.accountingPointsPU.filter((item) => {
      return item.счетчикид == this.counterId;
    });
  }

  showField(fieldName) {
    return this.indications.hasOwnProperty(fieldName);
  }

  indication(fieldName) {
    return this.indications[fieldName].предпок;
  }

  workingValue(fieldName) {
    return this.indications[fieldName].времянаработкипоказание;
  }

  indicationPrev(fieldName) {
    const previous = this.indications[fieldName]?.предпок;
    if (previous == null || previous === "") {
      return "";
    }
    const value = Number(previous);
    return Number.isFinite(value)
      ? value.toFixed(this.getFieldRateFloat(fieldName))
      : "";
  }

  zone(fieldName) {
    return this.indications[fieldName].зонатарифа;
  }

  // У объединённого узла каждый ПУ сохраняет собственную разрядность
  getFieldRate(fieldName: number): number {
    const raw = this.indications[fieldName]?.разрядность;
    const rate = raw == null || raw === "" ? NaN : Number(raw);
    return Number.isInteger(rate) && rate > 0 ? rate : this.rate;
  }

  getFieldRateFloat(fieldName: number): number {
    const raw = this.indications[fieldName]?.дробнаяразрядность;
    const rateFloat = raw == null || raw === "" ? NaN : Number(raw);
    return Number.isInteger(rateFloat) && rateFloat >= 0 ? rateFloat : this.rateFloat;
  }

  getMask(str: string, fieldName: number) {
    const rate = this.getFieldRate(fieldName);
    const rateFloat = this.getFieldRateFloat(fieldName);
    const integerMask = "".padStart(rate, str);
    const decimalMask = rateFloat > 0 ? "." + "".padStart(rateFloat, str) : "";
    return integerMask + decimalMask;
  }

  fieldRequired(fieldName: number) {
    return fieldName < this.zones
  }

  // меняем флаг в функции, т.к. computed не отрабатывает на массив
  changeRate(fieldName, value) {
    this.invalidRate[fieldName] = value;
    this.invalidRateFlag = this.invalidRate.filter((item, key) => item == true && key < this.zones).length > 0;
  }
  changeWorking(fieldName, value) {
    this.invalidWorking[fieldName] = value;
    this.invalidWorkingFlag = (this.invalidWorking.filter((item, key) => item == true && key < this.zones).length > 0);
  }
  changeWorkingTime(fieldName, value) {
    this.invalidWorkingTime[fieldName] = value;
    this.invalidWorkingTimeFlag = (this.invalidWorkingTime.filter((item, key) => item == true && key < this.zones).length > 0);
  }

  rateValidatorFor(fieldName: number) {
    const rate = this.getFieldRate(fieldName);
    const rateFloat = this.getFieldRateFloat(fieldName);
    const fractionalPart = rateFloat > 0 ? `([.,]\\d{1,${rateFloat}})?` : "";
    return new RegExp(`^\\d{1,${rate}}${fractionalPart}$`);
  }

  public validateRate(fieldName: number, readings: string) {
    this.rateFlag[fieldName] = false;

    if (!readings) {
      // не указано значение, форма невалидна, но не взводим ошибку на поле ввода
      this.changeRate(fieldName, true);
      return true;
    }

    if (!this.rateValidatorFor(fieldName).test(readings)) {
      // поле невалидно
      this.changeRate(fieldName, true);
      return false;
    }

    let currentIndication = readings;
    currentIndication = currentIndication.replace(/,/, '.');
    const readingsAsNumber = parseFloat(currentIndication);

    if (this.indication(fieldName) > readingsAsNumber && readingsAsNumber > 0) {
      // показание меньше предыдущего
      this.rateFlag[fieldName] = true;
    }

    this.changeRate(fieldName, false);

    this.submitError = "";

    return true;
  }

  public validateWorking(fieldName: number, readings: string) {
    this.workingFlag[fieldName] = false;

    if (!readings) {
      // не указано значение, форма невалидна, но не взводим ошибку на поле ввода
      this.changeWorking(fieldName, true);
      return true;
    }

    if (!((parseInt(readings, 10) | 0) === parseInt(readings, 10)) || parseInt(readings, 10) < 0) {
      // поле невалидно
      this.changeWorking(fieldName, true);
      return false;
    }

    let currentWorking = readings;
    currentWorking = currentWorking.replace(/,/, '.');
    const workingAsNumber = parseFloat(currentWorking);

    if (this.workingValue(fieldName) > workingAsNumber && workingAsNumber > 0) {
      // время наработки меньше предыдущего
      this.workingFlag[fieldName] = true;
    }

    this.changeWorking(fieldName, false);

    this.submitError = "";
    return true;
  }

  public validateWorkingTimeError(fieldName) {
    let result = [];
    if (this.elPu && this.workingTime[fieldName] != "") {
      // проверка на дату
      const currentDateTime = moment(this.workingTime[fieldName]);
      if (moment() < currentDateTime) {
        result = ['Дата должна быть не больше текущей'];
      } else {
        const ppDate = moment(this.indications[fieldName].предпокдата);
        if (ppDate.clone() >= currentDateTime.startOf('day')) {
          result = ['Дата должна быть больше предыдущей ' + ppDate.format('DD.MM.YYYY')];
        }
      }
    }

    // проверка на ошибки
    let invalid = result.length > 0;
    if (this.elPu) {
      this.workingTimeFlag[fieldName] = false;
      if (this.workingTime[fieldName] == "") {
        invalid = true;
      }
    }
    this.changeWorkingTime(fieldName, invalid);

    return result;
  }

  resetData() {
    // this.$refs.simpleForm.reset();
    // сброс значений показаний
    let { values, working, workingTime, $refs } = this;
    Object.keys(values).forEach(function(key, index) {
      working[key] = "";
      workingTime[key] = "";
      if ($refs[`workingTime${key}`] != undefined) {
        // @ts-ignore
        $refs[`workingTime${key}`].value = "";
      }

      values[key] = "";
    });
    this.$v.$reset();
  }

  showSuccessInfo() {
    this.useSuccessAlert = true;
  }

  submitForm() {
    this.submitError = "";

    // проверка взведенных флагов показаний по перекрутке
    if (this.rateFlag.filter((item, key) => item == true && key < this.zones).length > 0) {
      this.setMessage("Показание меньше предыдущего");
      this.setShow(true);
    } else if (this.workingFlag.filter((item, key) => item == true && key < this.zones).length > 0) {
      this.setMessage("Время наработки меньше предыдущего");
      this.setShow(true);
    } else {
      this.showDialog = true;
    }
  }

  sendData() {
    const values = this.getValues();

    let indications: Array<Indication> = [];
    for (let i = 0; i < this.zones; i++) {
      const currentIndication = values[i].replace(/,/, '.');
      const readingsAsNumber = parseFloat(currentIndication);

      let indication: Indication = {
        rate: i,
        readings: readingsAsNumber,
        twisting: 0,

      };

      // время наработки
      if (this.elPu) {
        indication.working = parseInt(this.working[i], 10);
        indication.workingTime = this.workingTime[i];
      }

      // добавлены поля для отправки
      const current = this.indications[i];
      indication.multi = current?.['объекты-узел'];
      indication.counterIdOriginal = current?.счетчикид_original;
      indication.zonesOriginal = current?.тарифность_original;
      indication.rateOriginal = current?.тариф_original;
      indication.numberOriginal = current?.заводскойномер_original;

      indications.push(indication);
    }

    this.useSubmitButtonLoading = true;
    this.sendCountersNewValue(
      this.meteringPointId,
      this.counterId,
      indications
    )
      .then(() => {
        this.resetData();
        this.showSuccessInfo();
        // перечитываем показания для отрисовки
        this.fetchAccountingPointsPU(this.contractId);
      })
      .catch(() => {
        this.resetData();
      })
      .finally(() => {
        this.useSubmitButtonLoading = false;
      });
  }
}

export default CountersNewValueForm;
